import { isUsingNewLayout } from '@app/adapters/silverfin'

function waitForSidepaneAnimationEnd(): Promise<void> {
  window.eventHub.$emit('openSidepane')

  const rightDrawer = document.getElementById('right-drawer')
  const mainContent = document.getElementById('main-content')

  return new Promise((resolve) => {
    function resolveOnEvent(): void {
      resolve()
      window.eventHub.$off('drawer:animation-end', resolveOnEvent)
    }

    const usingNewLayout = isUsingNewLayout()

    const isRightDrawerExpanded =
      rightDrawer &&
      (usingNewLayout
        ? !!document.querySelector(
            "#main-wrapper[data-right-drawer='expanded']"
          )
        : rightDrawer.classList.contains('sf-sidebar__expanded--right') &&
          !mainContent?.classList?.contains(
            'two-drawer-layout__main--transition'
          ))

    if (isRightDrawerExpanded) {
      resolve()
    } else {
      window.eventHub.$on('drawer:animation-end', resolveOnEvent)
    }
  })
}

export default waitForSidepaneAnimationEnd
